
import { useContext, useEffect } from 'react';
import { Box, styled, useMediaQuery, useTheme } from '@mui/material'
import TopSection from '../../../components/common/topSection/TopSection'
import FilterSection from '../../../components/common/filterSection/FilterSection'
import CompanyProfilesSection from '../../../components/companyProfiles_page/CompanyProfilesSection'
import FilterMobile from '../../../components/common/filterSection/FilterMobile';
import { ThemeContext } from '../../../context/ThemeContext';
import ContactPopupForm from '../../../components/common/ContactDialogBox/ContactPopUpForm';


const CompanyProfileBox = styled(Box)(({ theme }) => ({
  width: '68%',
  marginLeft: '2rem',
  marginRight: 0,
  [theme.breakpoints.down('mdlg')]: {
    width: '95%',
    marginRight: '0',
    marginLeft: '0',
  },
}));

const StyledContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingTop: '2rem',
  paddingBottom: '2rem',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  backgroundColor: '#fff',
  [theme.breakpoints.down('mdlg')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }
}));


function CompanyProfiles() {

  const { setInputValue, setFilterByCategory } = useContext(ThemeContext);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top whenever pathname changes
    return () => {
      setInputValue("");
      setFilterByCategory(null);
    };
  }, []);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('mdlg'));

  return (
    <>
      <ContactPopupForm/>
      <TopSection SectionTitle="Competitive Intelligence" />
      <StyledContainer>
        {isSmallScreen &&
          <Box sx={{ width: '95%', }} >
            <FilterMobile/>
          </Box>
        }
        <CompanyProfileBox>
          <CompanyProfilesSection/>
        </CompanyProfileBox>
          {!isSmallScreen &&
            <Box sx={{ width: '29%', height: 'auto', mr: '2rem' }} >
              <FilterSection/>
            </Box>
          }
      </StyledContainer>
    </>
  )
}

export default CompanyProfiles